import * as THREE from "three";
import {MESH} from "utils/constants";

class Mesh {
  static createMesh(scene, name, parent, index) {
    let geometry = null;
    switch (name) {
      case MESH.PLANE:
      case MESH.SQUARE: //code for old library. need to remove later
        geometry = new THREE.PlaneGeometry(1, 1, 1, 1);
        break;
      case MESH.BOX:
      case MESH.CUBE: //code for old library. need to remove later
        geometry = new THREE.BoxGeometry(1, 1, 1, 1, 1, 1);
        break;
      case MESH.CIRCLE:
        geometry = new THREE.CircleGeometry(1, 100, 0, Math.PI * 2);
        break;
      case MESH.CYLINDER:
        geometry = new THREE.CylinderGeometry(0.7, 0.7, 1.5, 20, 1, false, 0, Math.PI * 2);
        break;
      case MESH.SPHERE:
        geometry = new THREE.SphereGeometry(0.5, 32, 16, 0, Math.PI * 2, 0, Math.PI);
        break;
      case MESH.CONE:
        geometry = new THREE.ConeGeometry(1, 2, 4);
        break;
      case MESH.TORUS:
        geometry = new THREE.TorusGeometry(1, 0.4, 8, 20, Math.PI * 2);
        break;
      case MESH.CAPSULE:
        geometry = new THREE.CapsuleGeometry(1, 1, 4, 8);
        break;
      case MESH.DODECAHEDRON:
        geometry = new THREE.DodecahedronGeometry(1, 0);
        break;
      case MESH.ICOSAHEDRON:
        geometry = new THREE.IcosahedronGeometry(1, 0);
        break;
      case MESH.OCTAHEDRON:
        geometry = new THREE.OctahedronGeometry(1, 0);
        break;
      case MESH.TETRAHEDRON:
        geometry = new THREE.TetrahedronGeometry(1, 0);
        break;
      case MESH.LATHE:
        const points = [new THREE.Vector2(0, -0.5), new THREE.Vector2(0.5, 0), new THREE.Vector2(0, 0.5)];
        geometry = new THREE.LatheGeometry(points, 12, 0, Math.PI * 2);
        break;
      case MESH.TORUSKNOT:
        geometry = new THREE.TorusKnotGeometry(1, 0.4, 64, 8);
        break;
      case MESH.TUBE:
        const path = new THREE.CatmullRomCurve3([
          new THREE.Vector3(-10, 0, 10),
          new THREE.Vector3(-5, 5, 5),
          new THREE.Vector3(0, 0, 0),
          new THREE.Vector3(5, -5, 5),
          new THREE.Vector3(10, 0, 10),
        ]);
        geometry = new THREE.TubeGeometry(path, 20, 2, 8, false);
        break;
      case MESH.RING:
        geometry = new THREE.RingGeometry(0.5, 1, 20);
        break;
      case MESH.SPRITE:
        geometry = new THREE.RingGeometry(1, 5, 32);
        break;
      default:
        geometry = new THREE.BoxGeometry(1, 1, 1, 1, 1, 1);
        break;
    }
    const material = new THREE.MeshStandardMaterial({
      color: 0x5e80cb, //C9CEDB
      // flatShading: true,
      side: THREE.DoubleSide,
    });
    const mesh = new THREE.Mesh(geometry, material);
    mesh.position.set(0, 2, 0);
    mesh.castShadow = false;
    mesh.receiveShadow = true;
    mesh.layers.set(1);
    mesh.name = name;
    mesh.userData.friction = 1;
    mesh.userData.mass = 20;
    mesh.userData.canCollide = false;
    mesh.userData.isKinematic = true;
    mesh.userData.type = "mesh";
    mesh.userData.hasMap = false;
    mesh.userData.hasNormalMap = false;
    mesh.userData.hasEnvMap = false;

    return mesh;
  }
}
export default Mesh;
